import React from "react";

/** Matches the product name QRify (possessive 's stays outside italics). */
const QRIFY_RE = /(QRify)/g;

/** Inline brand mark — italic */
const QrifyMark = ({ children = "QRify", className = "" }) => (
  <em className={`sv-qrify ${className}`.trim()}>{children}</em>
);

const wrapInString = (text, keyPrefix) => {
  if (typeof text !== "string" || !text.includes("QRify")) {
    return text;
  }

  const parts = text.split(QRIFY_RE);
  return parts
    .map((part, i) => {
      if (!part) return null;
      if (part === "QRify") {
        return <QrifyMark key={`${keyPrefix}-${i}`}>{part}</QrifyMark>;
      }
      return part;
    })
    .filter((node) => node !== null);
};

/**
 * Wrap every QRify occurrence with .sv-qrify.
 * Accepts a string or an array of nodes (e.g. from other highlighters).
 */
export const highlightQrify = (input) => {
  if (typeof input === "string") {
    return wrapInString(input, "qr");
  }

  if (Array.isArray(input)) {
    return input.flatMap((node, i) => {
      if (typeof node !== "string") return [node];
      const wrapped = wrapInString(node, `qr-${i}`);
      return Array.isArray(wrapped) ? wrapped : [wrapped];
    });
  }

  return input;
};

export default QrifyMark;
